import React from 'react'
// components
import { Modal } from 'components/UI'
import SetResultRowForm from './Form'
// hooks
import useModalData from 'hooks/useShowModal'
// constants
import { Modals } from 'constants/index'
// utils
import isFunction from 'lodash/isFunction'

const SetResultRowModal = () => {
  const {
    hideModal,
    modalData: { isOpen, width, onSubmit, initialValues, closePopup, clearZoom, entity }
  } = useModalData({ modalType: Modals.KPI_SET_RESULT_ROW_MODAL })

  React.useEffect(() => closePopup && closePopup(), [closePopup])

  const handleCloseModal = () => {
    hideModal()

    if (isFunction(clearZoom)) {
      clearZoom()
    }
  }

  return (
    <Modal hideModal={hideModal} isOpen={isOpen} onClose={handleCloseModal} width={width}>
      <SetResultRowForm
        entity={entity}
        hideModal={handleCloseModal}
        initialValues={initialValues}
        onSubmit={onSubmit}
      />
    </Modal>
  )
}

export default SetResultRowModal
